import { render, staticRenderFns } from "./KpiReport.vue?vue&type=template&id=67c8881c&"
import script from "./KpiReport.vue?vue&type=script&lang=js&"
export * from "./KpiReport.vue?vue&type=script&lang=js&"
import style0 from "./KpiReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports